import React, { useEffect, useState } from 'react';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { 
  Container, 
  Box, 
  Paper, 
  Button, 
  Grid, 
  Typography, 
  Avatar, 
  useTheme 
} from '@mui/material';
import { 
  People as PeopleIcon,
  Assignment as HistoryIcon,
  LocalPharmacy as DrugsIcon,
  ExitToApp as LogoutIcon
} from '@mui/icons-material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import logo from '../assets/logowhite.png';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

const Home = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const theme = useTheme();
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/user`, { withCredentials: true });
                setUser(response.data);
            } catch (error) {
                navigate('/login');
            }
        };
        fetchUser();
    }, [navigate, API_URL]);

    const handleLogout = async () => {
        try {
            await axios.post(`${API_URL}/api/logout`, {}, { withCredentials: true });
            localStorage.removeItem('user');
            navigate('/login');
        } catch (error) {
            console.error('Error al cerrar sesión:', error);
        }
    };

    return (
        <Container maxWidth="lg" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Paper elevation={6} sx={{
                width: '100%',
                padding: { xs: 2, sm: 4 },
                borderRadius: 4,
                background: `linear-gradient(135deg, ${theme.palette.background.default} 0%,rgb(241, 244, 216) 100%)`,
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                //marginTop: '45px',
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 3
                }}>
                <Avatar
                    src={logo}
                    alt="Logo del Consultorio"
                    sx={{
                        width: { xs: 80, sm: 135 },
                        height: { xs: 80, sm: 135 },
                        boxShadow: 3,
                        mb: 2,
                        //border: `4px solid ${theme.palette.primary.main}`,
                        borderRadius: 0,
                        '& img': {
                            objectFit: 'contain'  // Esto asegura que la imagen se ajuste sin recortarse
                        }
                    }}
                />
                    
                    <Typography 
                        variant="h4" 
                        component="h1"
                        sx={{ 
                            fontWeight: 700,
                            color: theme.palette.primary.main,
                            textAlign: 'center',
                            textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
                            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' }
                        }}
                    >
                        Clínica Médica y Ultrasonido
                    </Typography>

                    <Grid container spacing={2} sx={{ mt: 2, width: '100%',justifyContent: 'center', alignItems: 'stretch' }}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Button
                                component={RouterLink}
                                to="/view-patients"
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<PeopleIcon fontSize="large" />}
                                sx={{
                                    py: 1.5,
                                    px: 1,
                                    borderRadius: 2,
                                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                    fontWeight: 600,
                                    transition: 'all 0.2s',
                                    boxShadow: 1,
                                    minHeight: '55px',
                                    '&:hover': {
                                        boxShadow: 3,
                                        backgroundColor: 'primary.dark'
                                    }
                                }}
                            >
                                Gestión de Pacientes
                            </Button>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Button
                                component={RouterLink}
                                to="/historias/2"
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<HistoryIcon fontSize="large" />}
                                sx={{
                                    py: 1.5,
                                    px: 1,
                                    borderRadius: 2,
                                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                    fontWeight: 600,
                                    transition: 'all 0.2s',
                                    boxShadow: 1,
                                    minHeight: '55px',
                                    '&:hover': {
                                        boxShadow: 3,
                                        backgroundColor: 'primary.dark'
                                    }
                                }}
                            >
                                Historias Clínicas
                            </Button>
                        </Grid>
                                
                        <Grid item xs={12} sm={6} md={4}>
                            <Button
                                component={RouterLink}
                                to="/historias-hoy"
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<HistoryIcon fontSize="large" />}
                                sx={{
                                    py: 1.5,
                                    px: 1,
                                    borderRadius: 2,
                                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                    fontWeight: 600,
                                    transition: 'all 0.2s',
                                    boxShadow: 1,
                                    minHeight: '55px',
                                    '&:hover': {
                                        boxShadow: 3,
                                        backgroundColor: 'primary.dark'
                                    }
                                }}
                            >
                                Historias de Hoy
                            </Button>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Button
                                component={RouterLink}
                                to="/diagnosticos-tratamientos"
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<HistoryIcon fontSize="large" />}
                                sx={{
                                    py: 1.5,
                                    px: 1,
                                    borderRadius: 2,
                                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                    fontWeight: 600,
                                    transition: 'all 0.2s',
                                    boxShadow: 1,
                                    minHeight: '55px',
                                    '&:hover': {
                                        boxShadow: 3,
                                        backgroundColor: 'primary.dark'
                                    }
                                }}
                            >
                                Bioestadística
                            </Button>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Button
                                component={RouterLink}
                                to="/drugs"
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<DrugsIcon fontSize="large" />}
                                sx={{
                                    py: 1.5,
                                    px: 1,
                                    borderRadius: 2,
                                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                    fontWeight: 600,
                                    transition: 'all 0.2s',
                                    boxShadow: 1,
                                    minHeight: '55px',
                                    '&:hover': {
                                        boxShadow: 3,
                                        backgroundColor: 'primary.dark'
                                    }
                                }}
                            >
                                Administrar Fármacos
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Button
                                href="https://sedimec.dictamenmedico.com/sedimec-med/login/auth"
                                target="_blank"
                                rel="noopener noreferrer"
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<HistoryIcon fontSize="large" />}
                                sx={{
                                    py: 1.5,
                                    px: 1,
                                    borderRadius: 2,
                                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                    fontWeight: 600,
                                    transition: 'all 0.2s',
                                    boxShadow: 1,
                                    minHeight: '55px',
                                    '&:hover': {
                                        boxShadow: 3,
                                        backgroundColor: 'primary.dark'
                                    }
                                }}
                            >
                                SEDIMEC
                            </Button>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Button
                                href="https://recetadigital.go.cr/"
                                target="_blank"
                                rel="noopener noreferrer"
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<DrugsIcon fontSize="large" />}
                                sx={{
                                    py: 1.5,
                                    px: 1,
                                    borderRadius: 2,
                                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                    fontWeight: 600,
                                    transition: 'all 0.2s',
                                    boxShadow: 1,
                                    minHeight: '55px',
                                    '&:hover': {
                                        boxShadow: 3,
                                        backgroundColor: 'primary.dark'
                                    }
                                }}
                            >
                                RECETA DIGITAL
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Button
                                component={RouterLink}
                                to="/contabilidad-medico"
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<MonetizationOnIcon fontSize="large" />}
                                sx={{
                                    py: 1.5,
                                    px: 1,
                                    borderRadius: 2,
                                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                    fontWeight: 600,
                                    transition: 'all 0.2s',
                                    boxShadow: 1,
                                    minHeight: '55px',
                                    '&:hover': {
                                        boxShadow: 3,
                                        backgroundColor: 'primary.dark'
                                    }
                                }}
                            >
                                Contabilidad Médico
                            </Button>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Button
                                component={RouterLink}
                                to="/contabilidad-secretaria"
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<AccountBalanceWalletIcon fontSize="large" />}
                                sx={{
                                    py: 1.5,
                                    px: 1,
                                    borderRadius: 2,
                                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                    fontWeight: 600,
                                    transition: 'all 0.2s',
                                    boxShadow: 1,
                                    minHeight: '55px',
                                    '&:hover': {
                                        boxShadow: 3,
                                        backgroundColor: 'primary.dark'
                                    }
                                }}
                            >
                                Contabilidad Secretaría
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Button
                                component={RouterLink}
                                to="/agenda-diaria"
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<AccountBalanceWalletIcon fontSize="large" />}
                                sx={{
                                    py: 1.5,
                                    px: 1,
                                    borderRadius: 2,
                                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                    fontWeight: 600,
                                    transition: 'all 0.2s',
                                    boxShadow: 1,
                                    minHeight: '55px',
                                    '&:hover': {
                                        boxShadow: 3,
                                        backgroundColor: 'primary.dark'
                                    }
                                }}
                            >
                                Agenda Diaria
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Button
                                component={RouterLink}
                                to="/agenda-medica"
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<CalendarTodayIcon fontSize="large" />}
                                sx={{
                                    py: 1.5,
                                    px: 1,
                                    borderRadius: 2,
                                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                    fontWeight: 600,
                                    transition: 'all 0.2s',
                                    boxShadow: 1,
                                    minHeight: '55px',
                                    '&:hover': {
                                        boxShadow: 3,
                                        backgroundColor: 'primary.dark'
                                    }
                                }}
                            >
                                Agenda Médica
                            </Button>
                            </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Button
                                component={RouterLink}
                                to="/agenda-procedimientos"
                                fullWidth
                                variant="contained"
                                size="large"
                                startIcon={<CalendarTodayIcon fontSize="large" />}
                                sx={{
                                    py: 1.5,
                                    px: 1,
                                    borderRadius: 2,
                                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                                    fontWeight: 600,
                                    transition: 'all 0.2s',
                                    boxShadow: 1,
                                    minHeight: '55px',
                                    '&:hover': {
                                        boxShadow: 3,
                                        backgroundColor: 'primary.dark'
                                    }
                                }}
                            >
                                Agenda de Procedimientos
                            </Button>
                            </Grid>
                    </Grid>

                    {user && (
                        <Button
                            onClick={handleLogout}
                            variant="contained"
                            color="secondary"
                            size="large"
                            startIcon={<LogoutIcon />}
                            sx={{
                                mt: 4,
                                px: 4,
                                borderRadius: 3,
                                fontWeight: 600,
                                boxShadow: 2,
                                '&:hover': {
                                    boxShadow: 4
                                }
                            }}
                        >
                            Cerrar Sesión
                        </Button>
                    )}
                </Box>
            </Paper>
        </Container>
    );
};

export default Home;